/**
 * Polling interval for payment completion (ms)
 */
export const PAYMENT_POLL_INTERVAL = 2000;

/**
 * Max polling time for payment completion (ms)
 */
export const PAYMENT_MAX_POLL_TIME = 60000;

/**
 * Bounded in-request retries for checkout/invoice webhook ordering.
 * A miss returns 500 so the payment provider can retry asynchronously.
 */
export const PAYMENT_RECORD_RETRY_ATTEMPTS = 5;

/**
 * Delay between in-request payment-record attempts (ms)
 */
export const PAYMENT_RECORD_RETRY_DELAY = 1000;

/**
 * Credit packs without a configured Stripe Price ID use this prefix and are
 * charged with inline `price_data` built from the package amount.
 */
export const INLINE_CREDIT_PRICE_PREFIX = 'inline-credit-';
